import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, EmptyCollection, ExportMenu, FilterComponent, ImportMenu, PageLoader, Pagination, STableLoader, } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import InventoryList from "../components/InventoryList";
import AddEditInventoryList from "../components/AddEditInventoryList";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import DeploymentMessage from "../../../../shared/components/DeploymentMessage";
import AddIcon from '@material-ui/icons/Add';

const InventoryObj = {
	name: null,
	remarks: null,
}

const InventoryHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
	return (
		<TableHead>
			<TableRow >
				<TableCell>{checkPermission('config_data', 'inventory_config', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'name' ? true : false}
						direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('name')}
					>
						Name
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'created_by' ? true : false}
						direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('created_by')}
					>
						Created By
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'updated_by' ? true : false}
						direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('updated_by')}
					>
						Last Updated By
					</TableSortLabel>
				</TableCell>
				<TableCell >
					<TableSortLabel
						active={sortInfo.sort === 'remarks' ? true : false}
						direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('remarks')}
					>
						Remarks
					</TableSortLabel>
				</TableCell>
			</TableRow>
		</TableHead>
	)
}

const InventoryType = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [isLoading, setLoading] = useState(false);
	const [filter, setFilter] = useState({});
	const [pageSelections, setPageSelections] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
	const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
	const [addEditInventories, setAddEditInventories] = useState({ modal: false, data: null });
	const [deleteInventory, setDeleteInventory] = useState({ modal: false, data: null });
	const [revertInventory, setRevertInventory] = useState({ modal: false, data: null });
	const [inventoryTypeInfo, setInventoryTypeInfo] = useState({ list: [], pagination: {} });

	useEffect(() => {
		getInventoryList({ per_page: 50 }, "skeletonLoader");
		trackActivity('Console Management', { page_title: 'Config Data : InventoryType', event_type: 'Page Visited' })
	},[])

	const getInventoryList = (query = {}, loaderType) => {
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
		globalGetService(`config-data/inventory-type/`, query)
			.then(response => {
				if (checkApiStatus(response)) {
					setInventoryTypeInfo(response?.data?.data)
					if (query) {
						delete query.page
						delete query.per_page
						delete query.sort
						delete query.sort_by
						setFilter(query)
					}
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
			})
	}

	const toggleBulkOps = (item, checked, currentPage) => {
		setPageSelections(prevSelections => {
			const updatedSelections = { ...prevSelections };
			if (checked) {
				updatedSelections[currentPage] = updatedSelections[currentPage] || [];
				updatedSelections[currentPage].push(item?.id);
			} else {
				updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
			}
			return updatedSelections;
		});
	};

	const onDelete = () => {
		setLoading(true);
		const ids = !deleteInventory.data ? Object.values(pageSelections).flat().filter(id => {
			const item = inventoryTypeInfo.list.find(item => item.id === id);
			return item && !item.deleted_at;
		}) : deleteInventory.data.id

		globalDeleteService(`config-data/inventory-type/bulk-delete/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setDeleteInventory({ modal: false, data: null });
					getInventoryList({...filter, page: inventoryTypeInfo?.pagination?.page, per_page: inventoryTypeInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : InventoryType',
						event_type: `Item Deleted`,
						event_desc: 'InventoryType Deleted Successfully',
						success_msg: response?.data?.message,
						deleted_id: ids
					});
				} else {
					setDeleteInventory({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : InventoryType',
						event_type: `Item Deleted`,
						event_desc: 'InventoryType Deletion Failed',
						error_msg: response?.data?.message,
						item_id: ids
					});
				}
			});
	};

	const onRevert = () => {
		setLoading(true);
		const ids = !revertInventory.data ? Object.values(pageSelections).flat().filter(id => {
			const item = inventoryTypeInfo.list.find(item => item.id === id);
			return item && item.deleted_at;
		}) : revertInventory.data;

		globalPutService(`config-data/inventory-type/restore/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setRevertInventory({ modal: false, data: null });
					getInventoryList({...filter, page: inventoryTypeInfo?.pagination?.page, per_page: inventoryTypeInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : InventoryType',
						event_type: `Item Reverted`,
						event_desc: 'InventoryType Reverted Successfully',
						success_msg: response?.data?.message,
						reverted_id: ids
					});
				} else {
					setRevertInventory({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : InventoryType',
						event_type: `Item Reverted`,
						event_desc: 'InventoryType Reversion Failed',
						error_msg: response?.data?.message,
						item_id: ids
					});
				}
			});
	};

	const handleSelectAll = (event, currentPage) => {
		if (event?.target.checked) {
			const allIds = inventoryTypeInfo?.list.filter(i=> !i?.is_default).map(item => item.id);
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
		} else {
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
		}
	};

	const getFilteredSelectionCounts = () => {
		let deleteCount = 0;
		let revertCount = 0;

		if (pageSelections[currentPage]?.length) {
			pageSelections[currentPage].forEach(id => {
				const selectedItem = inventoryTypeInfo?.list?.find(item => item?.id === id);
				if (selectedItem) {
					if (selectedItem?.deleted_at) {
						revertCount++;
					} else {
						deleteCount++;
					}
				}
			});
		}
		return { deleteCount, revertCount };
	};

	const { deleteCount, revertCount } = getFilteredSelectionCounts();

	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		getInventoryList({ ...filter, ...sortQuery, page: 1, per_page: inventoryTypeInfo?.pagination?.per_page || 20 }, 'pageLoader');
	}

	const isSelectAllChecked = inventoryTypeInfo?.list?.length > 0 && pageSelections[currentPage]?.length === inventoryTypeInfo?.list?.filter(i=> !i?.is_default)?.length;

	const getConfirmColor = () => {
        if (revertInventory?.modal || bulkRevert?.modal) return "primary";
        if (deleteInventory?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertInventory?.modal || bulkRevert?.modal) return "Revert";
        if (deleteInventory?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertInventory?.modal) return revertInventory.modal;
        if (deleteInventory?.modal) return deleteInventory.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertInventory?.modal) return "Revert Inventory Type";
        if (deleteInventory?.modal) return "Delete Inventory Type";
        if (bulkDelete?.modal) return `Delete Inventory Type (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Inventory Type (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertInventory?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteInventory?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertInventory?.modal) {
            setRevertInventory({ modal: false, data: null });
        } else if (deleteInventory?.modal) {
            setDeleteInventory({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertInventory?.modal || bulkRevert?.modal) return onRevert;
        if (deleteInventory?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

	const filterOption = (
		{
			'name': {
				'inputType': 'text',
				'title': 'Name',
			},
		})

	return (
		<section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
			<DeploymentMessage />
			<Paper className="tech-specs-card" style={{ height: `${window.innerHeight - 90}px` }}>
				<ConfigData />
				<div className="tech-specs-content" style={{ paddingTop: '0px' }}>
					{skeletonLoader ? <STableLoader count={6} /> :
					<div style={{ padding: '10px' }}>
						<Paper square style={{ padding: '4px 8px' }}>
							<Grid container spacing={1} alignItems="center">
								<Grid item md={6}>
											<FilterComponent
												filter={filter}
												filterMenu={filterOption}
												getResponseBack={(applyFilter) => { getInventoryList({ ...applyFilter, page: 1, per_page: inventoryTypeInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
											/>					
								</Grid>
								<Grid item md={6}>
									<ul className='list-inline flex-centered' style={{ float: 'right' }}>
										{revertCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : InventoryType', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from InventoryType` }) }} color="primary" size='small' variant="outlined">
													Revert ({revertCount})
												</Button>
											</li>
										)}
										{deleteCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : InventoryType', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from InventoryType` }) }} color="secondary" size='small' variant="contained">
													Delete ({deleteCount})
												</Button>
											</li>
										)}
										{checkPermission('config_data', 'inventory_config', 'C') && <li className='list-inline-item'>
											<Button onClick={() => setAddEditInventories({ modal: true, data: InventoryObj })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD Inventory Type</Button>
										</li>}
										
									</ul>
								</Grid>
							</Grid>
						</Paper>
						<Paper style={{ height: `${window.innerHeight - 200}px`, overflow: 'auto' }}>
							<Table className='mui-table-format' stickyHeader>
								<InventoryHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
									<TableBody>
										{inventoryTypeInfo?.list?.length > 0 && inventoryTypeInfo?.list?.map((item, index) =>
											<InventoryList
												item={item}
												index={index}
												onDelete={setDeleteInventory}
												onRevert={setRevertInventory}
												onEditFn={() => setAddEditInventories({ modal: true, data: item, type: 'edit' })}
												onViewFn={() => setAddEditInventories({ modal: true, data: item, type: 'view' })}
												toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
												bulkIds={pageSelections[currentPage] || []}
											/>
										)}
									</TableBody>
							</Table>
								{
									!inventoryTypeInfo?.list?.length ?
										<Paper>
											<div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div>
										</Paper>
										: null
								}
						</Paper>

						<Paper>
							<Pagination
								pagination={inventoryTypeInfo?.pagination}
								onChangePage={(event, newPage) => { getInventoryList({ ...filter, page: newPage + 1, per_page: inventoryTypeInfo.pagination?.per_page }, 'pageLoader'); setCurrentPage(newPage + 1) }}
								onChangeRowsPerPage={(event) => getInventoryList({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
							/>
						</Paper>
					</div>}
				</div>
				{addEditInventories.modal ?
					<AddEditInventoryList
						addEditInventory={addEditInventories}
						inventoryTypeInfo={inventoryTypeInfo}
						toggleModalFn={() => setAddEditInventories({ modal: false, data:[] })}
						getResponseBack={() => getInventoryList({...filter, page: inventoryTypeInfo?.pagination?.page, per_page: inventoryTypeInfo?.pagination?.per_page}, 'pageLoader')}
						modeType={addEditInventories?.type}
					/> : null
				}
				<DeletePopUp
					confirmColor={getConfirmColor()}
					confirmText={getConfirmText()}
					modal={getModal()}
					title={getTitle()}
					content={getContent()}
					toggleModalFn={toggleModalFn}
					deleteRecordFn={getDeleteRecordFn()}
				/>
			</Paper>
			{isLoading ? <PageLoader /> : null}
		</section>
	)
}
export default InventoryType;